/**
 * Cookie management functions.
 */

// Imports
import GlobalVars from '../GlobalVars';
import {
  isCheckout,
} from '../Utils';

function retroCookie(asName, asValue, aoOptions) {
  if (typeof asValue !== 'undefined') { // name and value given, set cookie
    if (window.Cookies) {
      window.Cookies.set(asName, asValue, aoOptions);
    }
  } else { // only name given, get cookie
    return (window.Cookies) ? window.Cookies.get(asName) : null;
  }

  return true;
}

function createCookieTemplate(asName, asValue, anDays, anMinutes) {
  let date = null;

  if (anDays) {
    date = new Date();
    date.setTime(date.getTime() + (anDays * 24 * 60 * 60 * 1000));
  } else if (anMinutes) {
    date = new Date();
    date.setTime(date.getTime() + (anMinutes * 60 * 1000));
  }

  if (date != null) {
    Cookies.set(asName, asValue, {
      expires: date
    });
  } else {
    Cookies.set(asName, asValue); // Session cookie
  }
}

function createCookie(asName, asValue, anDays) {
  createCookieTemplate(asName, asValue, anDays);
}

function createCookieMinutes(asName, asValue, anMinutes) {
  createCookieTemplate(asName, asValue, 0, anMinutes);
}

function writeCookie(
  asName, asValue, aoExpectedDate,
  asPath = null, asDomain = null, abSecure = false
) {
  let date = new Date();
  date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));

  if (aoExpectedDate) {
    date = aoExpectedDate;
  }

  const options = {
    expires: date,
  };

  if (asPath != null) {
    options.path = asPath;
  }

  if (asDomain != null) {
    options.domain = asDomain;
  }

  if (abSecure === true) {
    options.secure = true;
  }

  Cookies.set(asName, asValue, options);
}

function readCookie(asName) {
  return Cookies.get(asName);
}

function deleteCookie(asName) {
  Cookies.remove(asName);
}

function eraseCookieNoRefresh(asName) {
  createCookie(asName, '', -1);
}

function erasePersonnalization(asName) {
  const mySheaPrefix = 'MyShea_';
  const sku = asName.split(`ecomBag${GlobalVars.C}_`)[1];
  const cookieValue = Cookies.get(mySheaPrefix);

  if (cookieValue) {
    const oldBoxes = JSON.parse(cookieValue);

    for (let i = 0; i < oldBoxes.perso.length; i += 1) {
      const obj = oldBoxes.perso[i];

      if (obj.sku === sku) {
        oldBoxes.perso.splice(i, 1);

        i -= 1;
      }
    }

    if (oldBoxes.perso.length === 0) {
      Cookies.set(mySheaPrefix, null);
    } else {
      Cookies.set(mySheaPrefix, JSON.stringify(oldBoxes), { expires: 30 });
    }
  }
}

function eraseCookie(asName) {
  eraseCookieNoRefresh(asName);
  erasePersonnalization(asName);

  let newLocation = document.location;

  // from bag at checkout pages ?
  if (isCheckout() && asName.indexOf('ecomBag') === 0) {
    const matchs = asName.match(/^ecomBag(\d+)_(.+)$/);

    if (matchs.length === 3) {
      const toDelRegExp = /^sku=/;
      let hash = document.location.toString().split('#');
      let query = hash[0].split('?');

      if (query.length > 1) {
        let queryParams = query[1].split('&');
        const productParams = [];

        for (let i = 0; i < queryParams.length; i += 1) {
          if (!toDelRegExp.test(queryParams[i])) { // not a sku
            productParams.push(queryParams[i]);
          }
        }

        queryParams = productParams.join('&');
        query[1] = queryParams;
      }

      query = query.join('?');
      hash[0] = query;
      hash = hash.join('#');

      newLocation = hash;
    }
  }

  document.location.href = newLocation;
}

function erasePerso(asIdPerso, asCookieName) {
  const mySheaPrefix = 'MyShea_';
  let cookieValue = Cookies.get(asCookieName);
  const mySheaCookieValue = Cookies.get(mySheaPrefix);

  if (mySheaCookieValue) {
    const oldBoxes = JSON.parse(mySheaCookieValue);

    for (let i = 0; i < oldBoxes.perso.length; i += 1) {
      const obj = oldBoxes.perso[i];

      if (obj.id === asIdPerso) {
        oldBoxes.perso.splice(i, 1);

        i -= 1;
      }
    }

    if (oldBoxes.perso.length === 0) {
      Cookies.set(mySheaPrefix, null);
    } else {
      Cookies.set(mySheaPrefix, JSON.stringify(oldBoxes), { expires: 30 });
    }
  }

  // Name of the sku
  const cookieSku = asCookieName.split(`ecomBag${GlobalVars.C}_`);

  if (cookieValue) {
    // content of cookie
    const cookieProductArray = cookieValue.split('');

    const cookieProductQty = parseInt(cookieProductArray[0], 10) - 1;
    cookieProductArray[0] = cookieProductQty.toString();
    cookieValue = cookieProductArray.join('');

    createCookie(`ecomBag${GlobalVars.C}${cookieSku[1]}`, unescape(cookieValue), { expires: 30 });
  }

  document.location.href = document.location;
}

export {
  retroCookie,
  createCookie,
  createCookieMinutes,
  writeCookie,
  readCookie,
  deleteCookie,
  eraseCookie,
  eraseCookieNoRefresh,
  erasePersonnalization,
  erasePerso,
};



// WEBPACK FOOTER //
// ./js/common/tools/Cookie.js